import { makeStyles, Button, Container, Grid, Typography, TextField, Paper, Divider, Box, AppBar, Toolbar, Chip } from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import React, { useEffect, useMemo, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import QuizView from "./QuizView";
import data from '../curriculumData.json';
import { CurriculumMasterData } from "../../../services";
import { CurriculumDataService } from "../../../services";
import SectionLoader from '../../../sharedComponents/Loader/SectionLoader';
import Helper from "../../../common/Helper";
import moment from "moment";
import QuizReviewPage from "./QuizReviewPage";
import {AppDataContext} from '../../../common/AppContext'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexGrow: 1,
        //justifyContent: 'center',
        //alignItems: 'center'
    },
    headetText: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif !important',
        fontWeight: '600',
        color: '#8a5e1d',
    },
    headetSubText: {
        color: '#8a5e1d',
        paddingLeft: '8px',
        fontWeight: '500',
    },
    reviewContainer: {
        width: '100%',
        maxHeight: 'calc(100vh - 220px)',
        overflowY: 'auto',
        background: '#f0f2f5',
        padding: theme.spacing(2.5),
        borderRadius: theme.spacing(1),
    },
    reviewHeader: {
        background: 'linear-gradient(135deg, #1d428a 0%, #2758b8 100%)',
        borderRadius: theme.spacing(1.5),
        padding: theme.spacing(2.5, 3),
        marginBottom: theme.spacing(2.5),
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    reviewScoreRing: {
        width: 80,
        height: 80,
        borderRadius: '50%',
        border: '4px solid rgba(255,255,255,0.35)',
        background: 'rgba(255,255,255,0.12)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    reviewLegend: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    reviewLegendItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        padding: theme.spacing(0.5, 1.5),
        borderRadius: theme.spacing(2),
        background: '#ffffff',
        border: '1px solid #e0e0e0',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    },
    reviewLegendSwatch: {
        width: 10,
        height: 10,
        borderRadius: '50%',
    },
    reviewCard: {
        padding: theme.spacing(2.5),
        marginBottom: theme.spacing(2),
        borderRadius: theme.spacing(1.5),
        background: '#ffffff',
        boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
        border: '1px solid #e8eaf0',
    },
    reviewQuestionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        gap: theme.spacing(1),
        flexWrap: 'wrap',
    },
    reviewAnswerGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginTop: theme.spacing(0.5),
    },
    reviewAnswer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 1.5),
        borderRadius: theme.spacing(0.75),
        borderLeft: '3px solid transparent',
        transition: 'background 0.15s',
        flex: '1 1 calc(50% - 8px)',
        minWidth: 160,
        boxSizing: 'border-box',
    },
    reviewHelpBox: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1.5),
        padding: theme.spacing(1.5),
        borderRadius: theme.spacing(0.75),
    },
    reviewActionBar: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: theme.spacing(1),
        position: 'sticky',
        bottom: 0,
    }
}));

const QuizViewContainer = ({ questions, startedQuiz, handleQuizEnd, sectionID, subSectionID, curriculumID, isPreview, curriculumFlow, showReviewPage = true }) => {
    const classes = useStyles();
     const { addSnackMessages } = useContext(AppDataContext);
    const { state } = useLocation();
    const [totalNoOfQuestion, setTotalNoOfQuestion] = useState();
    const [enableNext, setEnableNext] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState()
    //const [questions, setQuestions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMediaLoading, setIsMediaLoading] = useState(false);
    const [documentURL, setDocumentURL] = useState('');
    const [answer, setAnswer] = useState();
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [questionStartEndTime, setQuestionStartTime] = useState({ startedQuizTime: null, endedQuizTime: null })
    const [userAnswer, setUserAnswer] = useState();
    const [completedQuizQuestions, setCompletedQuizQuestions] = useState([]);
    const [quizResponseJson, setQuizResponseJson] = useState({});
    const [showReviewScreen, setShowReviewScreen] = useState(false);
    const [hasStartedQuiz, setHasStartedQuiz] = useState(false);


    useEffect(() => {
        if (subSectionID) {
            setCurrentQuestion()
            setAnswer()
            setQuizResponseJson({});
            setShowReviewScreen(false);
            setHasStartedQuiz(false);

        }
    }, [subSectionID])

    const showSnackBarMessage = (message, severity = 'error') => {
          addSnackMessages([{
                    open: true,
                    message: message,
                    severity: severity
                }]);
    }

    useEffect(() => {
        //getAllQuestions();
        setTotalNoOfQuestion(questions.length);
    }, [questions])

    // const getAllQuestions = () => {
    //     setIsLoading(true)
    //     let filter = {
    //         questionLevelId: 0,
    //         filterText: '',
    //         pageSize: 10,
    //         pageIndex: 1
    //     }
    //     CurriculumMasterData.getQuestionBank(filter)
    //         .then(result => {
    //             if (result && result.data) {
    //                 setQuestions(result.data.sort((a, b) => a.id - b.id));
    //                 setTotalNoOfQuestion(result.data.length);
    //             }
    //             setIsLoading(false)
    //         }).catch((e) => {
    //             setIsLoading(false)
    //         });
    // }

    let completedQuestions = useMemo(() => {
        if (curriculumFlow && curriculumFlow.length > 0) {
            let res = curriculumFlow?.find(x => x.sectionId == sectionID && x.subSectionId == subSectionID);
            if (res && res.result.length > 0) {
                return res.result
                    .filter(x => {
                        const hasAnswer = typeof x?.answerGiven === 'string' && x.answerGiven.trim().length > 0;
                        return hasAnswer || x?.isCompleted === true || x?.isComplete === true;
                    })
                    .map(x => parseInt(x.questionID));
            }
        }
        return [];
    }, [sectionID, subSectionID, curriculumFlow])

    useEffect(() => {
        if (curriculumFlow && curriculumFlow.length > 0) {
            let res = curriculumFlow?.find(x => x.sectionId == sectionID && x.subSectionId == subSectionID);
            if (res && res.result.length > 0) {
                let existingCompletedQuestions = res.result.map(x => {
                    return { questionID: x.questionID, isCompleted: x.isCompleted, answerGiven: x.answerGiven, isCorrect: x.isCorrect }
                });
                setCompletedQuizQuestions(existingCompletedQuestions);
            }
        }

    }, [curriculumFlow])

    const completedQuestionIds = useMemo(() => {
        const ids = new Set(completedQuestions || []);
        (completedQuizQuestions || []).forEach((item) => {
            const hasAnswer = typeof item?.answerGiven === 'string' && item.answerGiven.trim().length > 0;
            if ((item?.isCompleted || item?.isComplete || hasAnswer) && item?.questionID) {
                ids.add(parseInt(item.questionID));
            }
        });
        return Array.from(ids);
    }, [completedQuestions, completedQuizQuestions])

    useEffect(() => {
        setDocumentURL(null);
        setAnswer(undefined);
        setEnableNext(false);
        if (!currentQuestion?.id) {
            setUserAnswer([]);
            return;
        }

        const isCurrentQuestionCompleted = completedQuestionIds.includes(currentQuestion.id);
        const selectedFromJson = quizResponseJson[currentQuestion.id];
        if (selectedFromJson && selectedFromJson.length > 0) {
            setUserAnswer(selectedFromJson);
            setEnableNext(isCurrentQuestionCompleted);
            return;
        }

        let res = curriculumFlow?.find(x => x.sectionId == sectionID && x.subSectionId == subSectionID);
        if (res && res.result) {

            let currQuesRes = res.result.find(x => x.questionID == currentQuestion?.id);
            if (currQuesRes) {
                const persistedAnswer = currQuesRes.answerGiven.length > 0 ? currQuesRes.answerGiven.split(',').map(x => parseInt(x)) : [];
                setUserAnswer(persistedAnswer);
                setQuizResponseJson((prev) => ({ ...prev, [currentQuestion.id]: persistedAnswer }));
                setAnswer({ isCorrect: currQuesRes.isCorrect })
                setEnableNext(isCurrentQuestionCompleted && persistedAnswer.length > 0)
                setQuestionStartTime({ startedQuizTime: currQuesRes.startTime, endedQuizTime: currQuesRes.endTime })
                return;
            }
        }
        setUserAnswer([]);
        setQuestionStartTime({ startedQuizTime: moment().utc().format(), endedQuizTime: null })
        if (currentQuestion && currentQuestion.documentName) {
            // getContentGalleryURL(currentQuestion.documentName);
        }
    }, [currentQuestion, curriculumFlow, quizResponseJson, completedQuestionIds])

    const getContentGalleryURL = async (selectedDocName) => {
        setIsMediaLoading(true);
        CurriculumMasterData.getMediaURL(selectedDocName).then((result) => {
            if (result)
                setDocumentURL(result);
        })
            .catch(err => {
                console.log(err)
            }).finally(e => {
                setIsMediaLoading(false);
            });
    }

    const updateNextButton = (value) => {
        setEnableNext(value)
    }

    const updateSubmitButton = (value) => {
        setEnableSubmit(value)
    }

    const handleNextClick = (comQuizQues = [...completedQuizQuestions]) => {
        let currQuestionId = currentQuestion?.id
        let index = questions.findIndex(x => x.id == currQuestionId)

        if (index > -1 && index < questions.length - 1) {
            let next = questions[index + 1]
            if (next) {
                setCurrentQuestion(next);
                setAnswer()
            }
        } else {
            if (isLast) {
                setShowReviewScreen(true)
                setCurrentQuestion()
            }
        }
    }

    const onPrevClick = () => {
        let currQuestionId = currentQuestion?.id
        let index = questions.findIndex(x => x.id == currQuestionId)
        if (index > -1 && index < questions.length) {
            let prev = questions[index - 1]
            if (prev) {
                setCurrentQuestion(prev);
                setAnswer()
            }
        }
    }

    const onSkipClick = () => {
        const currentQuestionId = currentQuestion?.id;
        if (currentQuestionId) {
            setQuizResponseJson((prev) => {
                if (!Object.prototype.hasOwnProperty.call(prev, currentQuestionId)) {
                    return prev;
                }

                const next = { ...prev };
                delete next[currentQuestionId];
                return next;
            });
        }
        setEnableSubmit(false);
        handleNextClick();
    }

    const onAnswerSelectionChange = (selectedAnswers = []) => {
        return;
    }

    const handleStartClick = () => {
        if (questions.length > 0) {
            let next = questions[0];
            setCurrentQuestion(next)
            startedQuiz(true)
            setShowReviewScreen(false)
            setHasStartedQuiz(true)

            setAnswer()
        }
    }

    const onQuestionNavigate = (question) => {
        if (!question || !question.id) {
            return;
        }
        setCurrentQuestion(question);
        setAnswer();
    }

    const isFirst = useMemo(() => {
        if (currentQuestion) {
            let firstQuestion = questions[0]
            if (firstQuestion.id === currentQuestion.id) {
                return true
            }
            return false
        }

    }, [currentQuestion])

    const isLast = useMemo(() => {
        if (currentQuestion) {
            let lastQuestion = questions[questions.length - 1]
            if (lastQuestion.id === currentQuestion.id) {
                return true
            }
            return false
        }
    }, [currentQuestion])

    const questionNo = useMemo(() => {
        if (currentQuestion) {
            let index = questions.findIndex(x => x.id == currentQuestion.id)
            return index + 1;
        }
    }, [currentQuestion])

    const allQuestionsAnswered = useMemo(() => {
        if (!questions || questions.length === 0) {
            return false;
        }

        return questions.every((question) => completedQuestionIds.includes(question.id));
    }, [questions, completedQuestionIds])

    const areAllQuestionsSubmitted = (questionResults = completedQuizQuestions) => {
        if (!questions || questions.length === 0) {
            return false;
        }

        return questions.every((question) => {
            const questionId = parseInt(question.id);
            return (completedQuestions || []).includes(questionId) ||
                (questionResults || []).some((item) =>
                    parseInt(item?.questionID) === questionId &&
                    typeof item?.answerGiven === 'string' &&
                    item.answerGiven.trim().length > 0
                );
        });
    }

    useEffect(() => {
        if (!showReviewPage || !hasStartedQuiz || showReviewScreen || currentQuestion?.id) {
            return;
        }

        if (areAllQuestionsSubmitted(completedQuizQuestions)) {
            setShowReviewScreen(true);
        }
    }, [showReviewPage, hasStartedQuiz, showReviewScreen, currentQuestion, completedQuizQuestions, questions, completedQuestions])

    const onIncompleteSubmit = (selectedAnswer = []) => {
        handleSubmitQuestion(selectedAnswer);
    }

    const moveToFirstUnansweredQuestion = (questionResults = completedQuizQuestions) => {
        if (!questions || questions.length === 0) {
            return;
        }

        const submittedQuestionIds = new Set(
            (questionResults || [])
                .filter((item) => item?.isCompleted === true && typeof item?.answerGiven === 'string' && item.answerGiven.length > 0)
                .map((item) => item.questionID)
        );

        const firstUnansweredQuestion = questions.find((question) => {
            return !submittedQuestionIds.has(question.id);
        });

        if (firstUnansweredQuestion) {
            setCurrentQuestion(firstUnansweredQuestion);
            setEnableSubmit(false);
            setAnswer();
        }
    }

    const submitCurrentAnswer = (selectedAnswer, onAfterSubmit) => {
        const isCurrentQuestionCompleted = completedQuestionIds.includes(currentQuestion?.id);
        if (!isCurrentQuestionCompleted) {
            var data = { "CurriculumID": curriculumID, "QuestionID": currentQuestion.id, "QuizAnswers": selectedAnswer }
            setEnableSubmit(false)
            let service = CurriculumDataService.validateAnswers;
            if (state?.isPublic) {
                service = CurriculumDataService.validatePublicAnswers;
            }
            service(data)
                .then(async (res) => {
                    let result=res.data;
                    let message=res.message;
                    if (result) {
                        setAnswer(result);
                        setEnableNext(true);
                        let _payload = {
                            curriculumID: curriculumID,
                            sectionID: sectionID,
                            subSectionID: subSectionID,
                            questionID: currentQuestion?.id,
                            startTime: questionStartEndTime.startedQuizTime,
                            endTime: moment().utc().format(),
                            answerGiven: selectedAnswer && selectedAnswer.length > 0 ? selectedAnswer.join(',') : '', //result?.isCorrect ? 1 : 0
                            isCorrect: result?.isCorrect ? true : false,
                        }
                        console.log(_payload);

                        setQuizResponseJson((prev) => ({
                            ...prev,
                            [currentQuestion.id]: selectedAnswer,
                        }));

                        const updatedQuizQuestions = upsertCompletedQuestion(currentQuestion?.id, selectedAnswer, result);

                        if (!isPreview && !state?.isPublic && Helper.isUserLoggedIn()) {

                            let res = CurriculumDataService.updateQuizQuestionStartEndTime(_payload);
                            console.log(res);
                            setQuestionStartTime({ ...questionStartEndTime, endedQuizTime: moment().utc().format() })
                        }

                        if (onAfterSubmit) {
                            onAfterSubmit(updatedQuizQuestions);
                        }

                        //setEnableSubmit(false);
                    }else if(result == 0 && message && message.length > 0){
                        showSnackBarMessage(message, 'error');
                    }
                })
                .catch(err => {
                    setEnableSubmit(true)
                    console.log(err)
                });
        } else if (onAfterSubmit) {
            onAfterSubmit(completedQuizQuestions);
        }
    }

    const upsertCompletedQuestion = (questionID, selectedAnswer, result) => {
        const nextQuestions = [...(completedQuizQuestions || [])];
        const existingIndex = nextQuestions.findIndex((item) => item?.questionID == questionID);
        const updatedQuestion = {
            questionID,
            isCompleted: true,
            answerGiven: selectedAnswer && selectedAnswer.length > 0 ? selectedAnswer.join(',') : '',
            isCorrect: result?.isCorrect ? true : false,
        };

        if (existingIndex > -1) {
            nextQuestions[existingIndex] = {
                ...nextQuestions[existingIndex],
                ...updatedQuestion,
            };
        } else {
            nextQuestions.push(updatedQuestion);
        }

        setCompletedQuizQuestions(nextQuestions);
        return nextQuestions;
    }

    const handleSubmitQuestion = (selectedAnswer) => {
        submitCurrentAnswer(selectedAnswer, (updatedQuizQuestions = completedQuizQuestions) => {
            const allSubmitted = areAllQuestionsSubmitted(updatedQuizQuestions);

            if (allSubmitted) {
                if (showReviewPage) {
                    setShowReviewScreen(true);
                } else {
                    handleQuizEnd(completedQuestions.length != updatedQuizQuestions.length, updatedQuizQuestions);
                }
                setCurrentQuestion();
                return;
            }

            if (isLast) {
                moveToFirstUnansweredQuestion(updatedQuizQuestions);
                return;
            }

            handleNextClick(updatedQuizQuestions);
        });
    }

    const handleReviewSubmit = () => {
        setShowReviewScreen(false);
        handleQuizEnd(completedQuestions.length != completedQuizQuestions.length, completedQuizQuestions);
    }

    const getSubmittedAnswersForQuestion = (questionId) => {
        const completedQuestion = (completedQuizQuestions || []).find((item) => item?.questionID == questionId);
        if (!completedQuestion || !completedQuestion.answerGiven) {
            return [];
        }

        return completedQuestion.answerGiven
            .split(',')
            .map((value) => parseInt(value))
            .filter((value) => !Number.isNaN(value));
    }

    return (<>
        <Box className={classes.root}>
            {isLoading ? <SectionLoader /> :
                showReviewScreen ?
                    <QuizReviewPage
                        questions={questions ?? []}
                        completedQuizQuestions={completedQuizQuestions}
                        handleReviewSubmit={handleReviewSubmit}
                        getSubmittedAnswersForQuestion={getSubmittedAnswersForQuestion}
                    />
                    
                    // <Box className={classes.reviewContainer}>
                      
                    //     {(() => {
                    //         const correctCount = (questions || []).filter(q => {
                    //             const cq = (completedQuizQuestions || []).find(item => parseInt(item.questionID) === parseInt(q.id));
                    //             return cq?.isCorrect === true;
                    //         }).length;
                    //         const totalCount = (questions || []).length;
                    //         const pct = totalCount > 0 ? Math.round((correctCount / totalCount) * 100) : 0;
                    //         const passBg = pct >= 70
                    //             ? 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)'
                    //             : 'linear-gradient(135deg, #1d428a 0%, #2758b8 100%)';
                    //         return (
                    //             <Box className={classes.reviewHeader} style={{ background: passBg }}>
                    //                 <Box>
                    //                     <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 4 }}>Quiz Review</Typography>
                    //                     <Typography variant="body2" style={{ opacity: 0.85 }}>
                    //                         {pct >= 70 ? 'Great work! Review your answers below.' : 'Review your answers and see where you can improve.'}
                    //                     </Typography>
                    //                 </Box>
                    //                 <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                    //                     <Box className={classes.reviewScoreRing}>
                    //                         <Typography variant="h5" style={{ fontWeight: 800, lineHeight: 1, color: '#fff' }}>{pct}<span style={{ fontSize: '0.6em', fontWeight: 600 }}>%</span></Typography>
                    //                         <Typography variant="caption" style={{ opacity: 0.8, color: '#fff', fontSize: '0.65rem' }}>SCORE</Typography>
                    //                     </Box>
                    //                     <Box textAlign="right">
                    //                         <Typography variant="h6" style={{ fontWeight: 700, lineHeight: 1 }}>{correctCount} / {totalCount}</Typography>
                    //                         <Typography variant="caption" style={{ opacity: 0.8, fontSize: '0.72rem' }}>Questions Correct</Typography>
                    //                     </Box>
                    //                 </Box>
                    //             </Box>
                    //         );
                    //     })()}

                       
                    //     <Box className={classes.reviewLegend}>
                    //         <Box className={classes.reviewLegendItem}>
                    //             <Box className={classes.reviewLegendSwatch} style={{ background: '#2e7d32' }} />
                    //             <Typography variant="caption" style={{ fontWeight: 500 }}>Correct Answer</Typography>
                    //         </Box>
                    //         <Box className={classes.reviewLegendItem}>
                    //             <Box className={classes.reviewLegendSwatch} style={{ background: '#c62828' }} />
                    //             <Typography variant="caption" style={{ fontWeight: 500 }}>Your Incorrect Selection</Typography>
                    //         </Box>
                    //         <Box className={classes.reviewLegendItem}>
                    //             <Box className={classes.reviewLegendSwatch} style={{ background: '#e0e0e0', border: '1px solid #bdbdbd' }} />
                    //             <Typography variant="caption" style={{ fontWeight: 500 }}>Not Selected</Typography>
                    //         </Box>
                    //     </Box>

                    
                    //     {(questions || []).map((question, index) => {
                    //         const submittedAnswerIds = getSubmittedAnswersForQuestion(question.id);
                    //         const completedQuestion = (completedQuizQuestions || []).find((item) => item?.questionID == question.id);
                    //         const isCorrect = completedQuestion?.isCorrect === true;
                    //         const helpText = isCorrect ? question.rightAnswerHelpText : question.wrongAnswerHelpText;

                    //         return (
                    //             <Paper key={question.id} className={classes.reviewCard} elevation={0}>
                    //                 <Box className={classes.reviewQuestionHeader}>
                    //                     <Box display="flex" flexDirection='column' style={{ gap: 8 }}>
                    //                         <Box component='div' display='flex' flexGrow={1} flexDirection='row'>
                    //                             <Box style={{
                    //                                 background: '#1d428a', color: '#fff',
                    //                                 borderRadius: 20, padding: '2px 12px',
                    //                                 fontSize: '0.72rem', fontWeight: 700, whiteSpace: 'nowrap'
                    //                             }}>
                    //                                 Q {index + 1}
                    //                             </Box>
                    //                             <Typography variant="subtitle2" style={{ fontWeight: 600, lineHeight: 1.4, marginLeft: 8 }}>
                    //                                 {Helper.stripHtmlTags(question?.questionTitle ?? '')}
                    //                             </Typography>
                    //                         </Box>
                    //                         <Box component='div'>
                    //                             <Typography variant="caption" style={{ fontSize: '0.65rem', color: '#616161' }}>
                    //                                 {question?.questionDescription ?? ''}
                    //                             </Typography>
                    //                         </Box>
                    //                     </Box>
                    //                     <Box style={{
                    //                         display: 'flex', alignItems: 'center', gap: 4,
                    //                         background: isCorrect ? '#e8f5e9' : '#ffebee',
                    //                         color: isCorrect ? '#2e7d32' : '#c62828',
                    //                         borderRadius: 20, padding: '3px 10px',
                    //                         fontSize: '0.72rem', fontWeight: 700, whiteSpace: 'nowrap',
                    //                         border: `1px solid ${isCorrect ? '#a5d6a7' : '#ef9a9a'}`,
                    //                     }}>
                    //                         {isCorrect
                    //                             ? <><CheckCircleIcon style={{ fontSize: 14, marginRight: 3 }} /> Correct</>
                    //                             : <><CancelIcon style={{ fontSize: 14, marginRight: 3 }} /> Incorrect</>
                    //                         }
                    //                     </Box>
                    //                 </Box>

                    //                 <Divider style={{ margin: '8px 0 10px' }} />

                    //                 <Box className={classes.reviewAnswerGrid}>
                    //                     {(question.answers || []).map((ans) => {
                    //                         const isUserSelected = submittedAnswerIds.includes(ans.id);
                    //                         let bg, borderColor, textColor, Icon = null;

                    //                         if (isCorrect && isUserSelected) {
                    //                             bg = '#f1f8f1'; borderColor = '#2e7d32'; textColor = '#1b5e20';
                    //                             Icon = <CheckCircleIcon style={{ fontSize: 18, color: '#2e7d32', flexShrink: 0 }} />;
                    //                         } else if (!isCorrect && isUserSelected) {
                    //                             bg = '#fdf1f1'; borderColor = '#c62828'; textColor = '#b71c1c';
                    //                             Icon = <CancelIcon style={{ fontSize: 18, color: '#c62828', flexShrink: 0 }} />;
                    //                         } else {
                    //                             bg = '#fafafa'; borderColor = 'transparent'; textColor = '#616161';
                    //                             Icon = null;
                    //                         }

                    //                         return (
                    //                             <Box
                    //                                 key={ans.id}
                    //                                 className={classes.reviewAnswer}
                    //                                 style={{ background: bg, borderLeftColor: borderColor }}
                    //                             >
                    //                                 {Icon}
                    //                                 <Typography variant="body2" style={{ color: textColor, fontWeight: ans.isCorrect || isUserSelected ? 500 : 400 }}>
                    //                                     {ans.answer}
                    //                                 </Typography>
                    //                             </Box>
                    //                         );
                    //                     })}
                    //                 </Box>

                    //                 {submittedAnswerIds.length === 0 && (
                    //                     <Typography variant="body2" color="textSecondary" style={{ marginTop: 8, fontStyle: 'italic' }}>No answer submitted.</Typography>
                    //                 )}

                    //                 {helpText && (
                    //                     <Box className={classes.reviewHelpBox} style={{
                    //                         background: isCorrect ? '#e8f5e9' : '#fff3e0',
                    //                         border: `1px solid ${isCorrect ? '#c8e6c9' : '#ffe0b2'}`,
                    //                     }}>
                    //                         <Typography variant="caption" style={{
                    //                             color: isCorrect ? '#2e7d32' : '#e65100',
                    //                             fontWeight: 600, letterSpacing: '0.4px', whiteSpace: 'nowrap',
                    //                         }}>
                    //                             {isCorrect ? '✓ TIP' : '! NOTE'}
                    //                         </Typography>
                    //                         <Typography variant="body2" style={{ color: isCorrect ? '#1b5e20' : '#bf360c', lineHeight: 1.5 }}>
                    //                             {helpText}
                    //                         </Typography>
                    //                     </Box>
                    //                 )}
                    //             </Paper>
                    //         );
                    //     })}

                    //     <Box className={classes.reviewActionBar}>
                    //         <Button
                    //             variant="contained"
                    //             color="primary"
                    //             size="large"
                    //             onClick={handleReviewSubmit}
                    //             style={{ minWidth: 140, fontWeight: 600, borderRadius: 24, padding: '8px 32px' }}
                    //         >
                    //             Continue
                    //         </Button>
                    //     </Box>
                    // </Box>
                    : <QuizView content={questions ?? []}
                        totalNoOfQuestion={totalNoOfQuestion}
                        updateNextBtnState={updateNextButton}
                        enableNext={enableNext}
                        handleNextClick={handleNextClick}
                        onStartClick={handleStartClick}
                        selectedQuestion={currentQuestion}
                        handlePrevClick={onPrevClick}
                        handleSkipClick={onSkipClick}
                        isFirst={isFirst}
                        isLast={isLast}
                        mediaURL={currentQuestion?.documentName ?? ''}
                        answer={answer}
                        handleSubmitQuestion={handleSubmitQuestion}
                        enableSubmit={enableSubmit}
                        updateSubmitButton={updateSubmitButton}
                        isMediaLoading={isMediaLoading}
                        userAnswer={userAnswer}
                        questionNo={questionNo}
                        onQuestionNavigate={onQuestionNavigate}
                        onAnswerSelectionChange={onAnswerSelectionChange}
                        completedQuestionIds={completedQuestionIds}
                        allQuestionsAnswered={allQuestionsAnswered}
                        onIncompleteSubmit={onIncompleteSubmit}
                    />
            }
        </Box>
    </>
    )
}

export default QuizViewContainer;